import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getFeedbackQuestions = createAsyncThunk(
  "feedback/getFeedbackQuestions",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.get("feedback/questions", { params });
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const addFeedbackQuestion = createAsyncThunk(
  "feedback/addFeedbackQuestion",
  async (questionData, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.post("feedback/questions", questionData);
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateFeedbackQuestion = createAsyncThunk(
  "feedback/updateFeedbackQuestion",
  async ({ questionId, questionData }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.put(`feedback/question/${questionId}`, questionData);
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteFeedbackQuestion = createAsyncThunk(
  "feedback/deleteFeedbackQuestion",
  async (questionId, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.delete(`feedback/question/${questionId}`);
      return { questionId, ...response.data };
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const FeedbackQuestionSlice = createSlice({
  name: "FeedbackQuestionSlice",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      total: 0,
      page: 1,
      limit: 20,
      totalPages: 1,
    },
  },
  reducers: {
    resetQuestionState: (state) => {
      state.isLoading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Questions
      .addCase(getFeedbackQuestions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFeedbackQuestions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.pagination = action.payload?.pagination || state.pagination;
      })
      .addCase(getFeedbackQuestions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Add Question
      .addCase(addFeedbackQuestion.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addFeedbackQuestion.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(addFeedbackQuestion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Update Question
      .addCase(updateFeedbackQuestion.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateFeedbackQuestion.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(updateFeedbackQuestion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Delete Question
      .addCase(deleteFeedbackQuestion.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteFeedbackQuestion.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(deleteFeedbackQuestion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetQuestionState } = FeedbackQuestionSlice.actions;
export default FeedbackQuestionSlice.reducer;
